import Service from '@ember/service';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';

export default class AdBlocker extends Service {
  @tracked isFacebookBlocked!: boolean;

  checkFacebook = task({ drop: true }, async (force = false) => {
    if (force === true || !this.isFacebookBlocked) {
      await this.checkFacebookTask.perform();
    }
  });

  checkFacebookTask = task({ drop: true }, async () => {
    try {
      await fetch('https://connect.facebook.net/en_US/sdk.js');

      // In general, ad-blocking addons, browsers, and software like pi-hole will trigger a NetworkError,
      // so we don't need to handle a specific response code here.
      return (this.isFacebookBlocked = false);
    } catch (err) {
      return (this.isFacebookBlocked = true);
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'ad-blocker': AdBlocker;
  }
}
